module.exports = __webpack_public_path__ + "img/unfinished_rabbit.87a8fe6d.png";